import type { ChatbotMessageWithIdentity } from '../../types/chatbot';

function messageSortTime(message: ChatbotMessageWithIdentity): number {
  if (typeof message.sequenceNumber === 'number') {
    return message.sequenceNumber;
  }
  const stamp = message.stamp ?? message.created;
  if (stamp) {
    const time = Date.parse(stamp);
    if (!Number.isNaN(time)) {
      return time;
    }
  }
  return 0;
}

export function sortChatbotMessagesAscending(
  messages: ChatbotMessageWithIdentity[],
): ChatbotMessageWithIdentity[] {
  return messages.slice().sort((left, right) => {
    return messageSortTime(left) - messageSortTime(right);
  });
}
